import React from 'react'
import { ListGroup, ListGroupItem } from 'react-bootstrap'
import map from 'lodash/map'
import type { OrderItemRow } from './OrderItemRow'
import { formatMoney } from '@ztechapps/common.utils'
import { HorizontalStack } from '@ztechapps/webui.util'
import { ProductCardSmall } from '../../components/ProductCardSmall'
import { AtPricePerUom } from '../../components/OrderPriceWrap'

/**
 * Use this on mobile or small screen
 * @returns {JSX.Element}
 * @constructor
 */
export const OrderItemsSmall = ({ items }: { items: OrderItemRow[] }) => {
  return (
    <div className="d-block d-lg-none ">
      <ListGroup>
        {map(items, ({ product, _id, net, price, quantity, uom, ...rest }, index) => (
          <ListGroupItem key={_id ?? index}>
            <ProductCardSmall {...product} />
            <small className={'text-warning'}>{rest?.remarks}</small>

            <HorizontalStack className="mt-4 justify-content-between ">
              <HorizontalStack>
                <div>{quantity}</div>
                <AtPricePerUom price={price} uom={uom?.name} />
              </HorizontalStack>

              <div>{formatMoney(net)} </div>
            </HorizontalStack>
          </ListGroupItem>
        ))}
      </ListGroup>
    </div>
  )
}
